import React from 'react';
import { DatePickerProps } from 'react-native-date-picker';

const DatePicker: React.FC<DatePickerProps> = () => null;

export default DatePicker;
